import { render } from "./HeroiconsOutlineSparkles.vue?vue&type=template&id=7094f7d4"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSparkles.vue"]])

export default __exports__